import React, { useContext, useEffect, useState } from "react";
import { Breadcrumb, Button, Card, Col, Form, Row } from "react-bootstrap";
import Layout from '../../layout/Layout';
import { Link, useNavigate, useParams } from "react-router-dom";
import { getServiceProvider, serviceProviderEdit, } from "./service";
import { toast } from "react-toastify";
import { AuthContext } from "../../AppContext";


const ServiceProviderAdd = () => {
    const { id } = useParams();
    const navigate = useNavigate()
    const { userPermission,token } = useContext(AuthContext)

    const [iaLoading, setIsLoading] = useState(false)
    const [servicesProvider, setServiceProvider] = useState({ service_name: "", status: 0 })
    const [validated, setValidated] = useState(false);

    const fetchServiceProvider = async () => {
        setIsLoading(true)
        try {
            const formData = new FormData()
            formData?.append("id", id)
            const response = await getServiceProvider(formData,token)
            if (response?.status) {
                setServiceProvider(response?.data)
            }
        } catch (error) {
            console.log('error', error)
        } finally {
            setIsLoading(false)
        }
    }

    /** handle Change input values*/
    const handleChange = (e, field) => {
        setServiceProvider((prev) => ({
            ...prev,
            [field]: e,
        }));
    }

    /**Save the service data  */
    const handleSubmit = async (event) => {
        setValidated(true)
        const form = event.currentTarget;
        event.preventDefault();

        if (form.checkValidity() === false) {
            event.stopPropagation();
        } else {
            setValidated(true);
            try {
                const formData = new FormData()
                id && formData?.append("id", id)
                formData?.append("name", servicesProvider?.name)
                formData?.append("status", servicesProvider?.status)
                const response = await serviceProviderEdit(formData,token)
                if (response?.status) {
                    if (id) {
                        toast.success("Services Update successfully");
                        navigate(`/service-provider/view/${id}`)
                    } else {
                        toast.success("Services Add successfully");
                        navigate(`/service-provider`)

                    }
                }
            } catch (error) {
                console.error('An error occurred:', error);
            }
        }
    };

    useEffect(() => {
        id && fetchServiceProvider()
    }, [id])
    return (
        <Layout sidebar={true}>
            <div className="page-heading">
                <h3>Services Provider {id ? "Edit" : "Add"}</h3>
                <Breadcrumb className="d-none d-sm-none d-md-none d-lg-block">
                    <Breadcrumb.Item >
                        <Link to="/"><i className='bx bx-home-alt me-2 fs-5' ></i> Home</Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item >
                        <Link to="/service-provider">Services Provider</Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item active>Services Provider {id ? "Edit" : "Add"}</Breadcrumb.Item>
                </Breadcrumb>
            </div>

            <div className="page-content">
                <Form noValidate validated={validated} onSubmit={handleSubmit}>
                    <Card className="mb-4 radiustop-0">
                        <Card.Body>
                            <Row>
                                <Col md={4}>
                                    <Form.Label>Service Provider Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="name"
                                        className="my-2"
                                        onChange={(e) => handleChange(e?.target?.value, "name")}
                                        value={servicesProvider?.name}
                                        required
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        Service Name Field Is Require
                                    </Form.Control.Feedback>
                                </Col>
                                <Col md={4}>
                                    <Form.Label htmlFor="status" className="d-block mb-2">
                                        Status
                                    </Form.Label>

                                    <Form.Check
                                        type="switch"
                                        onChange={(e) => handleChange(e?.target?.checked ? 1 : 0, "status")}
                                        name="status"
                                        checked={servicesProvider?.status === 1 ? true : false}
                                    />
                                </Col>

                            </Row>
                        </Card.Body>
                        <Card.Footer className="text-end">
                            <Button variant="primary" type="submit" className="me-3">Save</Button>
                            <Link to='/service-provider'>
                                <Button variant="secondary">Cancel</Button>
                            </Link>
                        </Card.Footer>
                    </Card>
                </Form>
            </div>
        </Layout>
    )
}

export default ServiceProviderAdd